// number-format.directive.ts
import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberFormat]',
  standalone:false
})
export class NumberFormatDirective implements AfterViewInit {
  constructor(private control: NgControl, private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const numericValue = value.replace(/,/g, '');
    if (!isNaN(Number(numericValue))) {
      const formattedValue = this.formatNumber(numericValue);
      this.control.control?.setValue(numericValue, { emitEvent: false });
      this.el.nativeElement.value = formattedValue; // Display formatted value
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const value = this.control.control?.value;
      if (value && !isNaN(Number(value))) {
        this.el.nativeElement.value = this.formatNumber(value.toString());
      }
    });
  }

  private formatNumber(value: string): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}